<section id="emailNotificationSection"
  class="d-flex flex-column justify-content-start align-items-start w-100 h-100 px-4 py-3">
  <div>
    <a id="emailBackToProductsLink" class="text-uppercase fw-bold" [routerLink]="['..']">
      <i class="fa fa-chevron-left" aria-hidden="true"></i> BACK TO PRODUCTS
    </a>

    <form [formGroup]="emailsForm">
      <div>
        <h3 class="text-uppercase mt-4 ps-3 form-label">INTERNAL NOTIFICATION EMAILS FOR
        INTEGRATIONS</h3>

        <h2 class="text-uppercase fst-italic red-text mt-5 form-label">NON-ZB EMPLOYEES
        CANNOT RECEIVE INTEGRATION NOTIFICATIONS</h2>

        @for (item of emailsForm.controls | keyvalue; track item.key) {
          <div>
            <div class="d-flex flex-row justify-content-start align-items-center">
              <div class="me-3">
                <input type="text" class="form-control form-control-sm" placeholder="Email Address"
                  formControlName="{{item.key}}">
              </div>
              <div>
                @if (!isManage(item.key)) {
                  <button type="button" class="btn btn-sm btn-outline-tertiary text-uppercase"
                  (click)="triggerEmailSave$.next(item.key)">Save</button>
                }
                @if (isManage(item.key)) {
                  <button type="button" class="btn btn-sm btn-outline-tertiary text-uppercase"
                  (click)="triggerManage$.next(item.key)">Manage</button>
                }
              </div>
            </div>
          </div>
        }
        <div class="mt-2">
          <button type="button" class="btn btn-sm btn-outline-tertiary text-uppercase"
          (click)="triggerAddEmail$.next(true)">+ ADD AN EMAIL</button>
        </div>
      </div>
    </form>

    <ng-container>
      <table class="table table-striped--reversed table-bordered mx-auto mt-4">
        <thead class="bg-primary tableHeader">
          <tr class="text-uppercase text-white">
            <th class="border-0 fw-normal" scope="col">Email</th>
            <th>DELETE</th>
          </tr>
        </thead>
        @if (allNotificationEmails$ | async; as allNotificationEmails) {
          <tbody class="tableBody">
            @for (address of allNotificationEmails; track address.emailAddress; let i = $index) {
              <tr>
                <td>{{ address.emailAddress }}</td>
                <td>
                  <button id="delete-email-address{{i}}" class="mx-1 btn btn-sm buttonIcon" (click)="triggerEmailDelete$.next(address.emailAddress)">
                    <i class="fa fa-xmark"></i>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
    </ng-container>
    @if (allNotificationEmails$ | async; as allRecords) {
      <div class="emptyResults p-auto h-100 w-100 text-center d-flex justify-content-center align-items-center">
        @if (allRecords.length === 0) {
          <div>
            There are no email addresses configured for notifications.
          </div>
        }
      </div>
    }
  </div>
</section>
